/**
 * Input Schema of ConfigAlerta
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ConfigAlerta} from '@/model/resource/ConfigAlerta'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputConfigAlertaSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputConfigAlerta'

  readonly fieldSet: FieldSet<ConfigAlerta> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
